import { Link } from "react-router-dom";
import { Button } from "@/components/ui/button";
import { Sparkles } from "lucide-react";

export default function DifferentiatorCallout({ testId = "differentiator-callout" }) {
  return (
    <section
      className="relative overflow-hidden rounded-xl border border-gold/40 bg-gradient-to-br from-white to-[#FBF7EE] p-8 sm:p-12"
      data-testid={testId}
    >
      <div className="pointer-events-none absolute -right-20 -top-20 h-60 w-60 rounded-full bg-gold/10 blur-3xl" />
      <div className="pointer-events-none absolute -bottom-24 -left-24 h-60 w-60 rounded-full bg-navy/5 blur-3xl" />
      <div className="relative flex flex-col gap-6 md:flex-row md:items-start">
        <div className="flex h-12 w-12 shrink-0 items-center justify-center rounded-md bg-navy text-gold">
          <Sparkles size={20} />
        </div>
        <div className="flex-1">
          <div className="text-[10px] font-semibold uppercase tracking-[0.2em] text-gold">
            The WillSeva Difference
          </div>
          <h3 className="mt-2 font-serif text-2xl leading-tight text-navy sm:text-3xl">
            Professionally structured wills. Senior-lawyer review when you need it.
          </h3>
          <p className="mt-4 max-w-3xl text-sm leading-relaxed text-[#4A5568] sm:text-base">
            Our drafting engine assembles a legally structured will from your inputs
            using deterministic, succession-law aligned templates. Our legal consultants
            are senior advocates specialising exclusively in succession, testamentary
            and estate planning law — ensuring every Will meets the highest legal standard.
          </p>
          <div className="mt-6 flex flex-wrap gap-3">
            <Link to="/will-generator">
              <Button className="bg-navy text-white hover:bg-[#1A2642]" data-testid={`${testId}-start-cta`}>
                Create My Will – ₹99
              </Button>
            </Link>
            <Link to="/pricing">
              <Button
                variant="outline"
                className="border-navy/30 text-navy hover:border-gold hover:bg-gold/10"
                data-testid={`${testId}-review-cta`}
              >
                See Senior Lawyer-Drafted Will
              </Button>
            </Link>
          </div>
        </div>
      </div>
    </section>
  );
}
